import React, { useEffect, useState } from 'react';
import axios from 'axios';
import IntranetLayout from './IntranetLayout';
import { Users, CalendarCheck, ClipboardList, Bot, Mail, AlertCircle, CheckCircle, UserCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StatCard = ({ icon, label, value, color }) => (
  <div className="bg-white rounded-xl p-5 border border-slate-100 flex items-center gap-4" data-testid={`stat-${label.toLowerCase().replace(/\s/g,'-')}`}>
    <div className={`w-12 h-12 ${color} rounded-xl flex items-center justify-center flex-shrink-0`}>{icon}</div>
    <div>
      <p className="text-2xl font-extrabold text-slate-900">{value}</p>
      <p className="text-sm text-slate-500">{label}</p>
    </div>
  </div>
);

export const IntranetDashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/intranet/stats`).then(r => setStats(r.data)).catch(console.error);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!stats) return <IntranetLayout><p className="text-slate-500">Chargement...</p></IntranetLayout>;

  return (
    <IntranetLayout>
      <div className="space-y-6">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-slate-900 mb-1">Tableau de bord</h2>
          <p className="text-sm text-slate-500">Vue d'ensemble de l'activité Ludotech Robotics</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard icon={<Users size={22} className="text-white" />} label="Élèves" value={stats.students} color="bg-[#1B6FE3]" />
          <StatCard icon={<CheckCircle size={22} className="text-white" />} label="Inscriptions actives" value={stats.inscriptions_active} color="bg-emerald-500" />
          <StatCard icon={<AlertCircle size={22} className="text-white" />} label="En attente" value={stats.inscriptions_pending} color="bg-amber-500" />
          <StatCard icon={<CalendarCheck size={22} className="text-white" />} label="Séances" value={stats.seances} color="bg-purple-500" />
          <StatCard icon={<UserCheck size={22} className="text-white" />} label="Présents aujourd'hui" value={stats.attendance_today || 0} color="bg-teal-500" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <StatCard icon={<Bot size={22} className="text-white" />} label="Robots" value={stats.robots} color="bg-[#F97316]" />
          <StatCard icon={<ClipboardList size={22} className="text-white" />} label="Expirées" value={stats.inscriptions_expired} color="bg-red-500" />
          <StatCard icon={<Mail size={22} className="text-white" />} label="Messages" value={stats.contacts} color="bg-sky-500" />
        </div>
      </div>
    </IntranetLayout>
  );
};

export default IntranetDashboard;
